import {
    DISABLE_MATCHING,
    ENABLE_MATCHING,
    REQUEST_ERROR,
    REQUEST_START,
    REQUEST_SUCCESS,
    START_MATCHING,
    STOP_MATCHING,
    BATTLE_MODE_FILTER_SET,
    VEHICLES_SELECT,
    INVENTORY_READINESS_UPDATE,
} from 'state/actions/players_matching'

import { AVAILABLE_UNITS_SET_FILTER } from 'state/actions/available_units'
import {
    BATTLE_ROOMS_TAB_STATES,
    LOCAL_STORAGE_KEYS,
    UNIT_TYPES,
} from 'constants'
import {
    getParsedStorageItem,
    restoreVehicleCds,
    restoreVehicleFilter,
    saveBattleRoomsVehicleLevel,
} from 'helpers/playersMatching'
import {
    FULL_UPDATE_FROM_SERVER,
    SMALL_UPDATE_FROM_SERVER,
    VEHICLES_FILTER_STATE_CHANGED,
} from '../actions/players_matching'

const isMatchingTabActive = (
    getParsedStorageItem(LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB) !== BATTLE_ROOMS_TAB_STATES.UNITS
)

const storedSelectedVehicleLevel = getParsedStorageItem(LOCAL_STORAGE_KEYS.BATTLE_ROOMS_VEHICLE_LEVEL)

export const initialState = {
    loading: false,
    vehicles: [],
    selected_vehicle_cds: null,  // Checked vehicles (filter irrelevant)
    vehiclesFilter: null,  // Filter by nation, vehicle type etc
    isVehiclesFilterOpen: false,
    active: isMatchingTabActive,
    vehicle_level: storedSelectedVehicleLevel,
    sortie_settings: [],
    start_time: null,
    end_time: null,
}

export const getInitialState = (vehicleLevel = storedSelectedVehicleLevel) => {
    const selected_vehicle_cds = restoreVehicleCds(vehicleLevel)
    const vehiclesFilter = restoreVehicleFilter(vehicleLevel)

    return {
        ...initialState,
        vehiclesFilter,
        selected_vehicle_cds,
    }
}

export default function reducer(state = getInitialState(), action) {
    if (!action) return state

    switch (action.type) {
    case VEHICLES_SELECT: {
        return {
            ...state,
            selected_vehicle_cds: action.payload.vehicle_cds,
            vehiclesFilter: action.payload.filter || state.vehiclesFilter,
        }
    }
    case BATTLE_MODE_FILTER_SET: {
        saveBattleRoomsVehicleLevel(action.payload.vehicle_level)

        return {
            ...state,
            vehicle_level: action.payload.vehicle_level,
            vehiclesFilter: restoreVehicleFilter(action.payload.vehicle_level),
        }
    }
    case AVAILABLE_UNITS_SET_FILTER: {
        const { level, unitType } = action.payload.filter

        const shouldUpdate = (
            unitType === UNIT_TYPES.SORTIE &&
            state.sortie_settings
                .filter(setting => setting.enabled || setting.show_challenges_message)
                .some(setting => setting.level === level)
        )

        const vehicleLevel = shouldUpdate ? level : state.vehicle_level
        const filter = shouldUpdate ? restoreVehicleFilter(vehicleLevel) : state.vehiclesFilter

        saveBattleRoomsVehicleLevel(vehicleLevel)

        return {
            ...state,
            vehicle_level: vehicleLevel,
            vehiclesFilter: filter,
        }
    }
    case VEHICLES_FILTER_STATE_CHANGED: {
        return {
            ...state,
            isVehiclesFilterOpen: action.payload.isOpened,
        }
    }
    default:
        return matchingReducer(state, action)
    }
}

function matchingReducer(state, action) {
    switch (action.type) {
    case START_MATCHING: {
        return {
            ...state,
            loading: false,
            start_time: action.payload.start_time,
            end_time: action.payload.end_time,
        }
    }
    case STOP_MATCHING: {
        return {
            ...state,
            loading: false,
            start_time: null,
            end_time: null,
        }
    }
    case ENABLE_MATCHING: {
        return {
            ...state,
            active: true,
        }
    }
    case DISABLE_MATCHING: {
        return {
            ...state,
            active: false,
        }
    }
    default:
        return matchingRequestReducer(state, action)
    }
}

function matchingRequestReducer(state, action) {
    switch (action.type) {
    case REQUEST_START: {
        return {
            ...state,
            loading: true,
            error: false,
        }
    }
    case REQUEST_ERROR: {
        return {
            ...state,
            loading: false,
            error: true,
        }
    }
    case REQUEST_SUCCESS: {
        return {
            ...state,
            loading: false,
            error: false,
            vehicles: action.payload.inventory,
        }
    }
    case INVENTORY_READINESS_UPDATE: {
        const vehicles = [...state.vehicles]
        const vehicleStateById = {}
        action.payload.forEach(vehicle => {
            vehicleStateById[vehicle.id] = vehicle
        })

        vehicles.forEach(vehicle => {
            if (vehicleStateById[vehicle.id]) vehicle.readiness = vehicleStateById[vehicle.id].readiness
        })

        return {
            ...state,
            vehicles,
        }
    }
    default:
        return unitsUpdateReducer(state, action)
    }
}

function unitsUpdateReducer(state, action) {
    switch (action.type) {
    case FULL_UPDATE_FROM_SERVER: {
        const {
            end_time,
            selected_vehicle_cds,
            sortie_settings,
            start_time,
            vehicle_level,
            vehiclesFilter,
        } = action.payload
        return {
            ...state,
            end_time,
            selected_vehicle_cds,
            sortie_settings,
            start_time,
            vehicle_level,
            vehiclesFilter,
        }
    }
    case SMALL_UPDATE_FROM_SERVER: {
        const {
            end_time,
            sortie_settings,
            start_time,
        } = action.payload
        return {
            ...state,
            end_time,
            sortie_settings,
            start_time,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/players_matching.js